import { gql } from '@grandvisionhq/graphql';

const storeOpeningTimesById = gql`
  fragment StoreOpeningTimesById on Store {
    monOpenClose {
      open
      close
    }
    tueOpenClose {
      open
      close
    }
    wedOpenClose {
      open
      close
    }
    thuOpenClose {
      open
      close
    }
    friOpenClose {
      open
      close
    }
    satOpenClose {
      open
      close
    }
    sunOpenClose {
      open
      close
    }
    specialOpenClosingHours {
      dateOpenClosed
      openClosed
      openClosedTime {
        open
        close
      }
    }
  }
`;
const GET_STORE_OPENING_TIMES_BY_ID = gql`
  query GetStoreOpeningTimesById($globalStoreId: ID) {
    store(globalStoreId: $globalStoreId) {
      ...StoreOpeningTimesById
    }
  }
  ${storeOpeningTimesById}
`;

export { GET_STORE_OPENING_TIMES_BY_ID };
//# sourceMappingURL=get-store-opening-times-by-id.js.map
